import { Box, Icon, LinearProgress, Typography } from '@mui/material'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ArrowBackOutlined } from '@mui/icons-material'
import SupersetDashboard from '../../Common/EmbeddedSuperset'
import { ReactElement } from 'react'
import { URLSearchParamsKeys } from '../../../constants/constants'
import { IAttribute } from '../../DTStudio/interfaces'
import { useTranslation } from 'react-i18next'
import { useGetEntityInstanceData } from '../../../CustomHooks/EntityInstances/getEntityInstanceData'
import { IEntityPreview } from '../../Entity/interfaces'
import { useAppSelector } from '../../../redux/hook'

const ViewAnalytics = (): ReactElement => {
    const [searchParams] = useSearchParams()
    const { t } = useTranslation()
    const loggedInOrgId = useAppSelector((state) => state.org.org?.id) || ''
    const viewID = searchParams.get(URLSearchParamsKeys.instanceId) || ''
    const navigate = useNavigate()

    const onBack = () => {
        navigate(-1)
    }

    const {
        data: entityData = {} as IEntityPreview,
        // isError: isLoadingEntityDataError,
        isFetching: isFetchingEntityData,
        isLoading: isLoadingEntityData,
    } = useGetEntityInstanceData(loggedInOrgId, viewID)

    if (isLoadingEntityData || isFetchingEntityData) {
        return <LinearProgress />
    }
    /**
     * We should we configure this "Id" & "Description" in Settings Tab in Analytics.
     * This configuration should be done by the super admin just how the configuration is done for the other applications
     * like facility monitioring and in transit applications.
     */
    const dashboardId = entityData?.attributes?.attributes?.find(
        (column: IAttribute) => column.name === 'Dashboard Id',
    )?.value
    const dashboardName = entityData?.attributes?.attributes?.find(
        (column: IAttribute) => column.name === t('dashboardDescription'),
    )?.value
    return (
        <Box
            sx={{
                p: 2,
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    marginBottom: '10px',
                }}
            >
                <Icon
                    onClick={() => onBack()}
                    sx={{ marginRight: '10px', cursor: 'pointer' }}
                    fontSize="small"
                >
                    <ArrowBackOutlined />
                </Icon>
                <Typography variant="h4" component="h2">
                    {dashboardName}
                </Typography>
            </Box>
            <Box
                style={{
                    overflowY: 'auto',
                    flexGrow: 1,
                }}
            >
                <SupersetDashboard dashboardId={dashboardId} />
            </Box>
        </Box>
    )
}

export default ViewAnalytics
